<app-page-title title="Patrimônio"></app-page-title>
<h3><label>Nome: </label> {{ patrimony?.description }}</h3>
<h3><label>Aquisição: </label>{{ patrimony?.acquisition_date | date: 'dd/MM/yyyy' }}</h3>
<h3><label>Tipo:</label>{{ patrimony?.type }}</h3>
<h3><label>Estado de conservação:</label>{{ patrimony?.conservation_state }}</h3>
<h3><label>Valor: </label>{{ patrimony?.value | currency: 'BRL' }}</h3>
<h3><label>Situação:</label>{{ patrimony?.situation }}</h3>
<h3><label>Observação:</label>{{ patrimony?.annotations }}</h3>
<button class="btn-back" mat-raised-button [routerLink]="['/patrimonio']">Voltar</button>
